import { darkTheme } from "@yleisradio/yds-core";
import styled, { css } from "styled-components";

import { UI_SIZE } from "../enums";
import { buttonStyle, fontFamily } from "../styles/global";

const buttonFontSize = 18;
const buttonFontWeight = "bold";

interface ResponsiveProps {
  uiSize: UI_SIZE;
}

export const OverlayButtonWrapper = styled.div`
  display: flex;
  height: 100%;
  pointer-events: none;
  position: absolute;
  right: 15px;
  text-decoration: none;
  top: 0;
`;

export const overlayLinkOrButtonStyle = css`
  ${buttonStyle};
  align-items: center;
  background-color: rgb(0 0 0 / 0%);
  display: flex;
  ${fontFamily};
  justify-content: space-around;
  padding: 0;
  position: relative;
  text-decoration: none;
  z-index: 2;

  span {
    display: none;
  }
`;

export const textButtonStyle = css<ResponsiveProps>`
  align-self: center;
  z-index: 2;
  ${props => {
    if (props.uiSize === UI_SIZE.DEFAULT) {
      return css`
        justify-content: initial;
        min-width: 52px;
        width: auto;
        font-size: ${buttonFontSize + "px"};
        font-weight: ${buttonFontWeight};

        span {
          color: ${darkTheme.TEXT_DEFAULT};
          display: block;
          margin-left: 25px;
          margin-right: 10px;
          opacity: 0.8;
        }

        svg {
          margin-left: 3px;
          margin-right: 17px;
          opacity: 0.8;
        }

        &:hover {
          span,
          svg {
            opacity: 1;
          }
        }
      `;
    }
  }}
`;

export const shareButtonStyle = css`
  border-radius: 26px;
  height: 52px;
  min-width: 52px;
`;
